import {
  Component,
  Input
} from '@angular/core';

import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';

import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BaseFieldRenderer } from '../../../core/runtime/base/base-field-renderer';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-text-renderer',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatFormField, MatFormFieldModule, MatInputModule],
  templateUrl: './text-renderer.component.html'
})

export class TextRendererComponent
extends BaseFieldRenderer {
}